import { createContext } from "react";

export interface RegisterStudentContextType {
    registerStudentState: any | undefined;
}

export const RegisterStudentContext = createContext<
    RegisterStudentContextType | any
>(undefined);
